export const LOCATION = Object.freeze({
  ROOT: '/',
  PROFILE: '/profile',
  DOCUMENT_DETAILS: '/document-details',
  UNITS: '/unit-details',
  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  IMPRINT: '/imprint',
  TERMS_OF_USE: '/terms-of-use',
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORBIDDEN: '/403'
});
